import React from 'react';
import Card from '../common/Card';

export default function StatCard({ label, value, icon, color = '#00B4FE' }) {
  return (
    <Card className="mol-stat-card">
      <div className="mol-stat-card__icon" style={{ backgroundColor: `${color}15`, color }}>
        {icon}
      </div>
      <div className="mol-stat-card__content">
        <span className="mol-stat-card__value">{value}</span>
        <span className="mol-stat-card__label">{label}</span>
      </div>
    </Card>
  );
}
